import { assoc, compose, pick } from 'ramda'

export const cleanRequest = item =>
  compose(
    pick(['id', 'content']), //
    assoc('content', JSON.stringify(item.content))
  )(item)
